import { PublicOnly, RequireAuth } from '@iris/ui/auth/guards';
import { createBrowserRouter } from 'react-router-dom';

import { Layout } from './layout';
import { RouteError } from './route-error';

/** Routes are lazy-loaded chunks (T4 §1.1); each screen arrives with its milestone. */
export const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <RouteError />,
    children: [
      {
        element: <PublicOnly />,
        children: [
          {
            path: 'login',
            lazy: async () => {
              const { LoginScreen } = await import('@iris/ui/auth/login-screen');
              return { Component: () => <LoginScreen signupHref="/signup" forgotHref="/forgot-password" /> };
            },
          },
          {
            path: 'signup',
            lazy: async () => ({ Component: (await import('@iris/ui/auth/signup-screen')).SignupScreen }),
          },
          {
            path: 'forgot-password',
            lazy: async () => ({
              Component: (await import('@iris/ui/auth/forgot-password-screen')).ForgotPasswordScreen,
            }),
          },
        ],
      },
      // the poster landing works logged in or not (FR-JOIN-02)
      { path: 'j/:joinCode', lazy: () => import('./routes/join') },
      // Explore and the shop pages are public too (owner decision M21): browse, then sign up and join
      { path: 'explore', lazy: () => import('./routes/explore') },
      { path: 'm/:merchantId', lazy: () => import('./routes/shop') },
      {
        path: 'reset-password',
        lazy: async () => ({
          Component: (await import('@iris/ui/auth/reset-password-screen')).ResetPasswordScreen,
        }),
      },
      {
        element: <RequireAuth />,
        children: [
          { index: true, lazy: () => import('./routes/wallet') },
          { path: 'cards/:merchantId', lazy: () => import('./routes/card') },
          { path: 'scan', lazy: () => import('./routes/scan') },
          { path: 'qr', lazy: () => import('./routes/qr') },
          { path: 'vouchers/:id', lazy: () => import('./routes/voucher') },
          { path: 'inbox', lazy: () => import('./routes/inbox') },
          { path: 'profile', lazy: () => import('./routes/profile') },
          { path: 'profile/privacy', lazy: () => import('./routes/privacy') },
          {
            path: 'welcome',
            lazy: async () => ({ Component: (await import('@iris/ui/auth/welcome-screen')).WelcomeScreen }),
          },
          {
            path: 'profile/sessions',
            lazy: async () => ({ Component: (await import('@iris/ui/auth/sessions-screen')).SessionsScreen }),
          },
        ],
      },
      { path: '*', lazy: () => import('./routes/not-found') },
    ],
  },
]);
